export enum ChangeUpdateStatusTypes {
  FETCH_CHANGE_UPDATE_STATUS_SUCCESS = "FETCH_CHANGE_UPDATE_STATUS_SUCCESS",
  FETCH_CHANGE_UPDATE_STATUS_FAILURE = "FETCH_CHANGE_UPDATE_STATUS_FAILURE",
  FETCH_CHANGE_UPDATE_STATUS_REQUEST = "FETCH_CHANGE_UPDATE_STATUS_REQUEST"
}